import React, { Component } from "react";
import PropTypes from "prop-types";
import "./styles.css";
import {
    setDownloadProperties,
    setDownloadSelectOpen,
} from "../../Home/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { clientErrorMessages, EMPTY_STRING } from "../../../constants";
import { rootStore } from "../../../redux/store";
import { setErrorState } from "../../../redux/error_banner/actions";
import xbtn from "../../../assets/close_x.svg";
import { getPlan } from "../../CreateTPlan_1Upload/helpers";
import {
    MODAL_STATES,
    NAV_PLAN_OPTIONS,
    DOWNLOAD_CARD_TITLE,
    DOWNLOAD_CARD_SUBTITLE,
    FILE_TYPE_HEADER,
} from "./constants";
import { DownloadGroupListItem } from "./DownloadGroupListItem";
import { If } from "react-if";
import { ReactComponent as CheckIcon } from "../../../assets/check.svg";
import { ReactComponent as XIcon } from "../../../assets/x_icon.svg";
import { ReactComponent as FileIcon } from "../../../assets/file_icon.svg";
import SpinLoader from "../SpinLoader";

class DownloadSelectCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalState: MODAL_STATES.INITIAL,
            currentTreatmentPlan: {},
            latestDownloadedFileType: EMPTY_STRING,
            latestDownloadedFileName: EMPTY_STRING,
        };

        this.handleClose = this.handleClose.bind(this);
        this.setModalState = this.setModalState.bind(this);
        this.setLatestDownloadedFileInfo =
            this.setLatestDownloadedFileInfo.bind(this);
        this.getDescriptionContents = this.getDescriptionContents.bind(this);
        this.fileTypes = this.fileTypes.bind(this);
    }

    componentDidMount() {
        let scope = this;
        /*
        Not super happy with copying to local state here, but letting a passed in
        plan short circuit the GET call avoids the race condition when this
        component is mounted on the review screen while DynamoDB is in an inconsistent state
         */
        if (this.props.currentTreatmentPlan) {
            this.setState({
                currentTreatmentPlan: this.props.currentTreatmentPlan,
            });
        } else {
            getPlan(
                this.props.authToken,
                this.props.patientuuid,
                this.props.planuuid
            )
                .then((payload) => payload.json())
                .then((json) => {
                    scope.setState({
                        currentTreatmentPlan: json.payload.plan,
                    });
                })
                .catch(() => {
                    rootStore.dispatch(
                        setErrorState(
                            true,
                            clientErrorMessages.TPLAN_RETRIEVE_FAILED
                        )
                    );
                });
        }
    }

    handleClose() {
        if (this.state.modalState === MODAL_STATES.DOWNLOADING) {
            return;
        }
        let selectOpen = false;
        let patientUuid = EMPTY_STRING;
        let planUuid = EMPTY_STRING;
        this.props.setDownloadProperties(selectOpen, patientUuid, planUuid);
    }

    componentWillUnmount() {
        this.handleClose();
    }

    setModalState(modalState) {
        this.setState({ modalState: modalState });
    }

    setLatestDownloadedFileInfo(fileType, fileName) {
        this.setState({
            latestDownloadedFileType: fileType,
            latestDownloadedFileName: fileName,
        });
    }

    getDescriptionContents() {
        return (
            <div>
                <If condition={this.state.modalState === MODAL_STATES.FINISHED}>
                    <div>
                        <div className="mb-3">
                            {this.state.latestDownloadedFileType}{" "}
                            {DOWNLOAD_CARD_SUBTITLE.DOWNLOAD_COMPLETE}
                        </div>
                        <div className="mb-3 break-all text-[#0880ae]">
                            <CheckIcon className="inline pr-2" />
                            {this.state.latestDownloadedFileName}
                        </div>
                    </div>
                </If>
                <If condition={this.state.modalState === MODAL_STATES.ERROR}>
                    <div className="text-error-500 mb-3">
                        <XIcon className="fill-error-500 inline pr-2" />{" "}
                        {this.state.latestDownloadedFileType}{" "}
                        {DOWNLOAD_CARD_SUBTITLE.ERROR}
                    </div>
                </If>
                <div>
                    {!this.props.pdfOnly &&
                        DOWNLOAD_CARD_SUBTITLE.SELECT_ANOTHER_FORMAT}
                </div>
            </div>
        );
    }

    fileTypes() {
        let fileTypesList = {};
        if (this.props.pdfOnly) {
            fileTypesList = { PDF: "Patient Report (PDF)" };
        } else fileTypesList = NAV_PLAN_OPTIONS;
        return Object.entries(fileTypesList).map(([key, value]) => {
            if (value === EMPTY_STRING) {
                return null;
            }
            return (
                <DownloadGroupListItem
                    key={key}
                    fileKey={key}
                    fileType={value}
                    useruuid={this.props.useruuid}
                    patientuuid={this.props.patientuuid}
                    planuuid={this.props.planuuid}
                    authToken={this.props.authToken}
                    currentTreatmentPlan={this.state.currentTreatmentPlan}
                    userData={this.props.userData}
                    modalState={this.state.modalState}
                    setModalState={this.setModalState}
                    setLatestDownloadedFileInfo={
                        this.setLatestDownloadedFileInfo
                    }
                    institutionUsersList={this.props.institutionUsersList}
                />
            );
        });
    }

    render() {
        return (
            <div className="click-outside-ignore download-select-overlay fixed top-0 flex h-screen w-screen justify-center bg-black/50 pt-20">
                <div className="tw-rounded-sm relative mt-[5%] h-3/5 max-h-112 w-1/2 max-w-188.5 min-w-150 border bg-white">
                    <img
                        className={`close-dl-btn ${
                            this.state.modalState ===
                                MODAL_STATES.DOWNLOADING &&
                            "close-dl-btn-not-clickable"
                        }`}
                        src={xbtn}
                        alt="Exit"
                        onClick={this.handleClose}
                    />
                    <div className="flex h-full w-full flex-row gap-2 p-8">
                        <div className="h-full basis-1/2">
                            <div className="h-full rounded-lg border border-solid border-[#cccccc]">
                                <ul className="mb-0">
                                    <li
                                        className={
                                            "list-group-item list-group-title-item rounded-tl-lg rounded-tr-lg text-xl"
                                        }
                                    >
                                        <FileIcon className="mr-3" />
                                        {FILE_TYPE_HEADER}
                                    </li>
                                </ul>
                                <ul
                                    id="download-list-file-type"
                                    className="h-70 overflow-y-scroll"
                                >
                                    {this.fileTypes()}
                                </ul>
                            </div>
                        </div>
                        <div className="basis-1/2">
                            <div className="h-full flex-col px-5 pt-20">
                                <div className="text-center text-3xl">
                                    {DOWNLOAD_CARD_TITLE}
                                </div>
                                <hr className="my-4 border" />
                                <div className="text-center text-lg">
                                    {this.state.modalState ===
                                        MODAL_STATES.INITIAL &&
                                        this.props.pdfOnly &&
                                        DOWNLOAD_CARD_SUBTITLE.PDF_ONLY}
                                    {this.state.modalState ===
                                        MODAL_STATES.INITIAL &&
                                        !this.props.pdfOnly &&
                                        DOWNLOAD_CARD_SUBTITLE.INITIAL}
                                    {this.state.modalState ===
                                        MODAL_STATES.DOWNLOADING && (
                                        <>
                                            <div className="mb-3">
                                                {
                                                    DOWNLOAD_CARD_SUBTITLE.DOWNLOADING
                                                }
                                            </div>
                                            <br />
                                            <div className="flex justify-center">
                                                <SpinLoader
                                                    width="50px"
                                                    height="50px"
                                                    loaderWidth="5px"
                                                    fgColor="var(--avendaTeal1)"
                                                />
                                            </div>
                                        </>
                                    )}
                                    {(this.state.modalState ===
                                        MODAL_STATES.FINISHED ||
                                        this.state.modalState ===
                                            MODAL_STATES.ERROR) &&
                                        this.getDescriptionContents()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DownloadSelectCard.propTypes = {
    currentTreatmentPlan: PropTypes.object,
    noBtnCallback: PropTypes.func,
    yesBtnCallback: PropTypes.func,
    useruuid: PropTypes.string,
    patientuuid: PropTypes.string,
    planuuid: PropTypes.string,
    authToken: PropTypes.string,
    id: PropTypes.string,
    userData: PropTypes.object,
    downloadProperties: PropTypes.object,
    setDownloadSelectOpen: PropTypes.func,
    setDownloadProperties: PropTypes.func,
    history: PropTypes.object,
    pdfOnly: PropTypes.bool,
    institutionUsersList: PropTypes.array,
};

const mapStateToProps = function (state, ownProps) {
    let patientuuid = ownProps.patientuuid
        ? ownProps.patientuuid
        : state.CreatePlanReducer.patientuuid;
    let planuuid = ownProps.planuuid
        ? ownProps.planuuid
        : state.CreatePlanReducer.planuuid;

    return {
        useruuid: state.LoginReducer.useruuid,
        authToken: state.LoginReducer.authToken,
        patientuuid: patientuuid,
        planuuid: planuuid,
        downloadProperties: state.HomeReducer.downloadProperties,
        userData: state.LoginReducer.userData,
        institutionUsersList: state.HomeReducer.institutionUsersList,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        setDownloadSelectOpen: (active) =>
            dispatch(setDownloadSelectOpen(active)),
        setErrorState: (hasError, errorText) =>
            dispatch(setErrorState(hasError, errorText)),
        setDownloadProperties: (selectOpen, patID, planID) =>
            dispatch(setDownloadProperties(selectOpen, patID, planID)),
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DownloadSelectCard)
);
